import apiConfig from "@/config/apiConfig";

const rootPath = apiConfig.companyApi;
const rootPa = apiConfig.commonApi;

export const companyInfo = {
    detail: rootPath + "/enterpriseCompanyOriginInfo/detailInfo",   //  获取当前企业详情
    saveorupdate: rootPath + "/enterpriseCompanyOriginInfo/updateCompanyInfo",   // 更新企业信息
}

export const companyDigitalInfo = {
    detail: rootPath + "/digitalService/current",   //  获取当前企业详情
    save: rootPath + "/digitalService/save",   // 更新企业信息
}

export const messagesNum = {
    messagesNum: rootPa + "/menuMessagesNum/webList",
}

//财务
export const finance = {
    pageList: rootPa + "/enterpriseFinanceInfo/pageList",   //  分页
    remove: rootPa + "/enterpriseFinanceInfo/remove/",   // 删除
    detail: rootPa + "/enterpriseFinanceInfo/detailCode",   // 详情
    saveOrUpdate: rootPa + "/enterpriseFinanceInfo/saveOrUpdate",   // 新增编辑
}

//兑现依据
export const EnterprisePolicyBasis = {
    getByType: rootPa + "/enterprisePolicyBasis/getByType",
}

//资质荣誉
export const honor = {
    detail: rootPa + "/enterpriseHonorsInfo/detail",   // 详情
    pageList: rootPa + "/enterpriseHonorsInfo/pageList",   // 分页
    remove: rootPa + "/enterpriseHonorsInfo/remove/",   // 删除
    saveOrUpdate: rootPa + "/enterpriseHonorsInfo/saveOrUpdate",   // 新增编辑

}

//扩展
export const extendApi = {
    detail: rootPa + "/enterpriseRulesInfo/detail",   // 详情
    saveOrUpdate: rootPa + "/enterpriseRulesInfo/saveOrUpdate",   // 新增编辑
}

//高级人才
export const talentApi = {
    pageList: rootPath + "/enterpriseTalentInfo/pageList",   // 分页
    detail: rootPath + "/enterpriseTalentInfo/detail",   // 详情
    remove: rootPath + "/enterpriseTalentInfo/remove/",   // 删除
    saveOrUpdate: rootPath + "/enterpriseTalentInfo/saveOrUpdate",   // 新增编辑
}
